export default __webpack_public_path__ + "static/media/mall-icon.d0854cc3.svg";